import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  width: 96px;
  min-height: 36px;
  margin-top: 30px;
  margin-bottom: 50px;
  @media (max-width: 1400px) {
    margin-bottom: 64px;
  }
`;
